import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Grid, TablePagination } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { agendaLimpiar, fetchTurnosCanceladosEliminados } from '../../../actions/turnos/agenda';
import { useForm } from "../../../hooks/useForm";
import { ValidatorForm } from 'react-material-ui-form-validator';
import { ParametrosConsultaBaja } from './ParametrosConsultaBaja';
import { ListaConsultaTurnosBaja } from './ListaConsultaTurnosBaja';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: 5,
        flexGrow: 1,
        marginTop: 5,
    },
    input: {
        padding: 10,
    },
    grid: {
        backgroundColor: theme.palette.background.paper,
    },
    formControl: {
        marginTop: 5,
        minWidth: 120,
        marginLeft: 20,
        margin: theme.spacing(1),
    }, 
    button: {
        marginLeft: 25,
    }
}));

const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

const formatFecha = fecha => {
    return new Date(fecha).toLocaleString(
        "es",
        optionsfecha
    );
};

const stateInitial = {
    fechaDesde: new Date(),
    fechaHasta: new Date(),
    idParametrizacion: '',
    idMotivoBajaTurno: '',
    tomadoLibre: 0,
};  

export const HomeConsultaBajas = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { items, cargada } = useSelector((state) => state.agenda);
    const { items: itemsParametrizaciones } = useSelector((state) => state.efectorHorarios);
    const [idCentroMedico, setIdCentroMedico] = useState(null);
    const [idProfesional, setIdProfesional] = useState(null);
    const [idEspecialidad, setIdEspecialidad] = useState(null);
    const [listaItems, setListaItems] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const [ formValues, handleInputChange, , setearValor ] = useForm(stateInitial);
    const { fechaDesde, fechaHasta, idParametrizacion, tomadoLibre } = formValues;

    const handleInputChangeCascada = ({ target }) => {
        switch (target.name) {
            case 'idCentroMedico':
                setIdCentroMedico(target.value);
                setIdProfesional(null);
                setIdEspecialidad(null);
                break;
            case 'idProfesional':
                if(target.value === ''){
                    setIdProfesional(null);
                }
                else{
                    setIdEspecialidad(null);
                    setIdProfesional(target.value);
                }
                break;
            case 'idEspecialidad':
                setIdEspecialidad(target.value);
                break;
            default:
                break;
        }
        dispatch( agendaLimpiar() );
    }

    useEffect(() => {
        dispatch( agendaLimpiar() );
    }, [dispatch]);

    useEffect(() => {
        setListaItems(items);
    }, [items]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleFilterSearch=(value)=>{
        if(value===0)
            setListaItems(items);
        if(value===1)
            setListaItems(items.filter(s => s.idAfiliado));
        else if(value===2)
            setListaItems(items.filter(s => !s.idAfiliado));
    }

    const handleSubmitSearch = e => {
        dispatch( fetchTurnosCanceladosEliminados(fechaDesde.toISOString(), fechaHasta.toISOString(), idCentroMedico, idProfesional, idEspecialidad) );
        handleInputChange({target:{name: 'tomadoLibre', value: 0}})
    }

    return ( 
        <>
            <ValidatorForm onSubmit={handleSubmitSearch}>
                <div className={classes.root}>
                    <Grid container className={classes.root} justify="center" spacing={1}>  
                        <Grid item xs={8} style={{backgroundColor: 'white'}}>
                            <ParametrosConsultaBaja
                                classes={classes}
                                fechaDesde={fechaDesde}
                                fechaHasta={fechaHasta}
                                setearValor={setearValor}
                                idProfesional={idProfesional}
                                idCentroMedico={idCentroMedico}
                                idEspecialidad={idEspecialidad}
                                idParametrizacion={idParametrizacion}
                                setIdEspecialidad={setIdEspecialidad}
                                itemsParametrizaciones={itemsParametrizaciones}
                                handleInputChangeCascada={handleInputChangeCascada}
                            />
                        </Grid>
                        <Grid item xs={11}>
                            <ListaConsultaTurnosBaja
                                page={page}
                                cargada={cargada}
                                items={listaItems}
                                tomadoLibre={tomadoLibre}
                                formatFecha={formatFecha}
                                rowsPerPage={rowsPerPage}
                                handleInputChange={handleInputChange}
                                handleFilterSearch={handleFilterSearch}
                            />
                        </Grid>
                        <Grid item xs={11}>
                            {cargada&& listaItems.length > 0&&
                                <>
                                    <TablePagination
                                        style={{backgroundColor: 'white'}}
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={listaItems.length}
                                        rowsPerPage={rowsPerPage}
                                        labelRowsPerPage='Registros por página'
                                        page={page}
                                        onChangePage={handleChangePage}
                                        onChangeRowsPerPage={handleChangeRowsPerPage}
                                    />
                                </>
                            }
                        </Grid>
                    </Grid>
                </div>
            </ValidatorForm>
        </>
     );
}